<template>
    <div class="faq-pad mx-auto">
        <div v-for="(item, index) in allData"
             :key="index">
            <div class="font-weight-bold mx-3 category"
                 :class="{'pt-40':index!==0, 'border-top': index!==0}">{{item.category}}</div>
            <div class="mt-3"
                 :class="{'mb-5': index!==allData.length-1, 'mb-3': index===allData.length-1}">
                <div v-for="(subitem, i) in item.blocks"
                     class="mx-3 box"
                     :key="i">
                    <div class="three-square d-flex flex-row">
                        <div class="square d-flex flex-row align-items-center"
                             :class="{opened: sub.isOpen}"
                             v-for="(sub, j) in subitem.blocks"
                             @click="openAnswer(index, i, j)"
                             :key="j">
                            <div class="square-title font-weight-bold"
                                 v-html="sub.title"></div>
                            <b-icon-dash-circle-fill class="square-icon text-white"
                                                     v-if="sub.isOpen" />
                            <b-icon-plus-circle-fill class="square-icon text-white"
                                                     v-else/>
                        </div>
                    </div>
                    <div class="answer my-3 font-weight-bold"
                         v-if="subitem.isOpen"
                         v-html="subitem.value"></div>
                </div>
            </div>
        </div>
        <Back class="mx-3"
              direction="left"
              :customBack="customBack"
              @callback="callback" />
    </div>
</template>

<script>
import Back from '@/components/Back.vue';

export default {
    name: 'PadFaq',
    components: {
        Back
    },
    props: {
        data: Array,
        customBack: Boolean
    },
    data() {
        return {
            allData: []
        };
    },
    created() {
        this.getData();
    },
    watch: {
        data() {
            this.getData();
        }
    },
    methods: {
        getData() {
            this.data.forEach((item, index) => {
                const newArray = [];
                for (let i = 0; i < item.children.length; i += 2) {
                    const item1 = item.children[i];
                    const item2 = item.children[i + 1];
                    const array = [];
                    if (item1) {
                        array.push({ ...item1, isOpen: false });
                    } if (item2) {
                        array.push({ ...item2, isOpen: false });
                    }
                    const json = {
                        blocks: array,
                        isOpen: false,
                        value: ''
                    };
                    newArray.push(json);
                }
                item.blocks = newArray;
            });
            this.allData = JSON.parse(JSON.stringify(this.data));
        },
        callback() {
            this.$emit('callback');
        },
        closeAll() {
            this.allData.forEach(item => {
                item.blocks.forEach(subitem => {
                    subitem.isOpen = false;
                    subitem.blocks.forEach(nextItem => {
                        nextItem.isOpen = false;
                    });
                });
            });
        },
        openAnswer(index, i, j) {
            if (!this.allData[index].blocks[i].blocks[j].isOpen) {
                this.closeAll();
            }
            this.allData[index].blocks[i].isOpen = !this.allData[index].blocks[i].isOpen;
            this.allData[index].blocks[i].value = this.allData[index].blocks[i].blocks[j].answer;
            this.allData[index].blocks[i].blocks[j].isOpen = !this.allData[index].blocks[i].blocks[j].isOpen;

            this.allData = JSON.parse(JSON.stringify(this.allData));
        }
    },

};
</script>
